module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/thumbs/7-d2db8de3b5b1cab970353992fa2aa453.webp";